import { render, staticRenderFns } from "./DashboardDefault.vue?vue&type=template&id=e5baf7d8&scoped=true&lang=pug&"
import script from "./DashboardDefault.vue?vue&type=script&lang=js&"
export * from "./DashboardDefault.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDefault.vue?vue&type=style&index=0&id=e5baf7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5baf7d8",
  null
  
)

export default component.exports